var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-customer" }, [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: { label: "Nombre de cliente", "label-for": "privateName" }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateName",
                  placeholder: "Rafaeli Camposorio Ruízo",
                  icon: "account",
                  disabled: true,
                  loading: _vm.loading
                },
                model: {
                  value: _vm.privateName,
                  callback: function($$v) {
                    _vm.privateName = $$v
                  },
                  expression: "privateName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            { attrs: { label: "Email", "label-for": "privateEmail" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateEmail",
                  placeholder: "correo@mail.com",
                  icon: "email",
                  type: "email",
                  disabled: true,
                  loading: _vm.loading
                },
                model: {
                  value: _vm.privateEmail,
                  callback: function($$v) {
                    _vm.privateEmail = $$v
                  },
                  expression: "privateEmail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            { attrs: { label: "RFC", "label-for": "privateRfc" } },
            [
              _c("BInput", {
                attrs: {
                  id: "privateRfc",
                  placeholder: "PAL7202161U0",
                  icon: "fingerprint",
                  pattern: _vm.rfcPattern,
                  disabled: true,
                  loading: _vm.loading
                },
                model: {
                  value: _vm.privateRfc,
                  callback: function($$v) {
                    _vm.privateRfc = $$v
                  },
                  expression: "privateRfc"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Razón social",
                "label-for": "privateCompanyName"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCompanyName",
                  placeholder: "Machete SA de CV",
                  icon: "domain",
                  disabled: true,
                  loading: _vm.loading
                },
                model: {
                  value: _vm.privateCompanyName,
                  callback: function($$v) {
                    _vm.privateCompanyName = $$v
                  },
                  expression: "privateCompanyName"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Días de crédito",
                "label-for": "privateCreditDays"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCreditDays",
                  placeholder: "30",
                  icon: "bank",
                  disabled: true,
                  loading: _vm.loading
                },
                model: {
                  value: _vm.privateCreditDays,
                  callback: function($$v) {
                    _vm.privateCreditDays = $$v
                  },
                  expression: "privateCreditDays"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "BField",
            {
              attrs: {
                label: "Limite de crédito",
                "label-for": "privateCreditLimit"
              }
            },
            [
              _c("BInput", {
                attrs: {
                  id: "privateCreditLimit",
                  placeholder: "30",
                  icon: "bank",
                  disabled: true,
                  loading: _vm.loading
                },
                model: {
                  value: _vm.privateCreditLimit,
                  callback: function($$v) {
                    _vm.privateCreditLimit = $$v
                  },
                  expression: "privateCreditLimit"
                }
              })
            ],
            1
          ),
          _c("p", { staticClass: "help" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("toCurrency")(_vm.privateCreditLimit, "MXN")) +
                "\n      "
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }